
import $ from 'jquery';
import navigationViewport from './navigation--viewport.js';
import './menuAim.js';
	var subnavSelector = '.navigation--sub, .navigation--sub-sub, .navigation--container';

	function sublevelHeight (targets) {
		if(window.fitNavigationViewport === 'desktop') {
			targets.each(function () {
				var $target = $(this);
				var $heightTargets = $target.add($target.find(subnavSelector));
				var heights = [];
				$heightTargets.addClass('navigation--invisible');
				$heightTargets.each(function() {
					heights.push($(this).height());
				});
				$heightTargets.height(Math.max.apply(null, heights));
				$heightTargets.removeClass('navigation--invisible');
			});
		}
	}
	function resetSublevelHeight (targets) {
		targets.each(function () {
			var $target = $(this);
			var $heightTargets = $target.add($target.find(subnavSelector));
			$heightTargets.css('height', '');
		});
	}

	navigationViewport.then(function() {
		var $firstSubLevels = $('.navigation--main > .navigation__item > .navigation--sub');
		sublevelHeight($firstSubLevels);

		document.body.addEventListener('navigationChange', function () {
			resetSublevelHeight($firstSubLevels);
			sublevelHeight($firstSubLevels);
		});
	});
